/* ========== View ========== */
//Blake Gilmore 4/25 AI used to figure out lit-html
import { BookmarkModel } from './model.js';
import { html, render } from 'lit-html';
import { map } from 'lit-html/directives/map.js';

/**
 * Owns all DOM interaction — reading form inputs, building bookmark HTML,
 * and wiring user events — so the model stays free of any browser/DOM
 * concerns and the controller never touches the DOM directly.
 */
export class BookmarkView {
  /**
   * Caches references to the key DOM elements once at construction time
   * so every subsequent read or write avoids repeated querySelector calls.
   */
  constructor() {
    this.app = document.querySelector('.bookmarks-list');
    this.form = document.querySelector('.bookmark-form');
    this.urlInput = document.getElementById('url');
    this.descriptionInput = document.getElementById('description');
  }

  /**
   * Provides the controller with the current URL value while stripping
   * leading/trailing whitespace to avoid accidental blank-space mismatches.
   */
  get url() {
    return this.urlInput.value.trim();
  }

  /**
   * Provides the controller with the current description value while
   * stripping leading/trailing whitespace for clean storage.
   */
  get description() {
    return this.descriptionInput.value.trim();
  }

  /**
   * Clears the form after a successful add so the user is ready to enter
   * the next bookmark without having to manually clear the fields.
   */
  resetForm() {
    this.form.reset();
  }



  /**
   * Rebuilds the entire bookmark list in the DOM whenever the data changes,
   * keeping the displayed list in sync with the model's current state.
   * Build the HTML for all bookmarks using a for loop.
   */
  //DONE but I have no idea how i did this
 displayBookmarks(bookmarks) {
  const template = html`
    ${map(bookmarks, (bookmark, i) => html`
      <div class="bookmark-item content" data-index="${i}">
        <a href="${bookmark.link}" target="_blank" rel="noopener noreferrer" class="bookmark">
          <div class="img" style="background-image:url(${bookmark.image})">&nbsp;</div>
          <div class="title">${bookmark.title}<br>${bookmark.description}</div>
        </a>
        <button name="deleteBookmark" type="button" class="btn p-0 border-0 delete-button" aria-label="Delete bookmark">
          <i class="bi-trash delete-icon"></i>
        </button>
      </div>
    `)}
  `;
  render(template, this.app);
}

  /**
   * Attaches the submit listener to the form so user-initiated adds flow
   * through built-in HTML5 validation first, then through the model's URL
   * safety check, before the handler is allowed to commit the new bookmark.
   */
  onAddBookmark(handler) {
    this.form.addEventListener('submit', (event) => {
      event.preventDefault();

      if (!this.form.checkValidity()) {
        this.form.reportValidity();
        return;
      }

      const added = handler(this.url, this.description);
      if (!added) {
        this.urlInput.setCustomValidity('Please enter an http or https URL.');
        this.form.reportValidity();
        this.urlInput.setCustomValidity('');
        return;
      }

      this.resetForm();
    });
  }

  /**
   * Uses event delegation on the bookmark list container so a single click
   * listener handles delete buttons for all current and future bookmark
   * items without needing to re-attach listeners after every re-render.
   */
  onDeleteBookmark(handler) {
    this.app.addEventListener('click', (event) => {
      const deleteButton = event.target.closest('button[name="deleteBookmark"]');
      if (!deleteButton) {
        return;
      }

      const bookmarkItem = deleteButton.closest('[data-index]');
      const index = parseInt(bookmarkItem.getAttribute('data-index'), 10);
      handler(index);
    });
  }
}